import {
  Box,
  Drawer,
  Button,
  IconButton,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { rem } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadNoticeListAction } from "redux/reducers/notice/index";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";

export default function selectStore({ open, setOpen }) {
  const [val, setVal] = useState("");
  const [storeList, setStoreList] = useState([]);
  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      store: "ALL",
    },
  });
  const handleSelectStoreClose = () => {
    setOpen(false);
  };

  const changeStore = (e) => {
    setVal(e.target.value);
  };

  const dispatch = useDispatch();
  const { schForm, listStatus } = useSelector((state) => state.notice);

  const onChangeStore = () => {
    dispatch(
      loadNoticeListAction({ ...schForm, schStore: getValues("store"), pg: 1 })
    );
    handleSelectStoreClose();
  };

  const fetchData = () => {
    axios
      .get(`/api/st/store-code`, {
        params: {
          tp: schForm.schTp,
          useYn: "Y",
        },
      })
      .then((res) => {
        if (res.data.data) setStoreList(res.data.data);
      });
  };

  useEffect(() => {
    if (open) {
      setValue("store", schForm.schStore);
      fetchData();
    }
  }, [open]);

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleSelectStoreClose}
      className="drawer-common-bottom size-high"
    >
      <div className="drawer-head">
        <h3>{schForm.schTp == 1 ? "메가마트" : "메가마켓"} 매장 선택</h3>
        <IconButton
          aria-label="close"
          className="btn-close"
          onClick={handleSelectStoreClose}
        >
          <span className="hidden">닫기</span>
        </IconButton>
      </div>
      <div className="drawer-body">
        <Box className="box-type-1">
          <Controller
            defaultValue=""
            id="store"
            name="store"
            control={control}
            render={({ field }) => (
              <FormControl component="fieldset">
                <FormLabel
                  component="legend"
                  focused={false}
                  className="hidden"
                >
                  메가마트 매장 선택
                </FormLabel>
                <RadioGroup aria-label="store" name="store" {...field}>
                  <FormControlLabel
                    value=""
                    control={
                      <Radio
                        color="primary"
                        icon={<span className="radio-icon" />}
                        checkedIcon={<span className="radio-icon-checked" />}
                      />
                    }
                    label="전체매장"
                  />
                  {storeList.map((store, i) => (
                    <FormControlLabel
                      key={store.cd}
                      value={store.cd}
                      control={
                        <Radio
                          color="primary"
                          icon={<span className="radio-icon" />}
                          checkedIcon={<span className="radio-icon-checked" />}
                        />
                      }
                      label={store.nm}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            )}
          />
        </Box>
      </div>
      <div className="drawer-foot">
        <Button color="primary" variant="contained" onClick={onChangeStore}>
          선택완료
        </Button>
      </div>
    </Drawer>
  );
}
